export default {
    text: `Une mise à jour de l'application est disponible. Afin de profiter des dernières fonctionnalités, veuillez recharger l'application`,
    button: `Recharger l'application`,
};
